import * as React from "react";
import { useState } from "react";
import { useField } from "formik";
import Store from "logic/local-storage/Store";
import { SearchFiltersFormControls } from "components/common";
import { ControlLabel } from "components/bootstrap";
import { Col } from "security-app/components/common/FormBaseStyles";
import { ErrorMessage } from "./ErrorMessage";
export const PLUGGABLE_CONTROLS_HIDDEN_KEY = "pluggableSearchBarControlsAreHidden";
function FormikSearchFiltersFormControl({ field, label = null }) {
  const [searchFiltersHidden, setSearchFiltersHidden] = useState(Store.get(PLUGGABLE_CONTROLS_HIDDEN_KEY));
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField({ name: field.name });
  const onChange = (filters) => {
    setValue(filters.toArray());
    setTouched(true);
  };
  const hideFiltersPreview = (hideFilters) => {
    Store.set(PLUGGABLE_CONTROLS_HIDDEN_KEY, hideFilters);
    setSearchFiltersHidden(hideFilters);
  };
  const getSearchFilters = () => value || [];
  return !searchFiltersHidden ? /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    SearchFiltersFormControls,
    {
      filters: getSearchFilters(),
      onChange,
      hideFiltersPreview
    }
  ), touched && error && /* @__PURE__ */ React.createElement(ErrorMessage, null, error)) : null;
}
export default FormikSearchFiltersFormControl;
